/** @app — application layer; owned per-fork (LMS / OTT). See PLATFORM_FILES.md. */
//
// Barrel export for the course-detail shared kit. Variants import from
// here so the underlying file structure stays an implementation detail.

export { COURSE_DETAIL_CSS } from './styles';
export type { CourseDetailProps, TabSpec } from './styles';

export { Breadcrumb } from './Breadcrumb';
export { AiHighlightsBlock } from './AiHighlightsBlock';
export { CareerBlock } from './CareerBlock';
export { CertificateBadge } from './CertificateBadge';
export { ChapterTree } from './ChapterTree';
export { CourseLayout } from './CourseLayout';
export { CourseTabs } from './CourseTabs';
export { CourseTitleBlock } from './CourseTitleBlock';
export { FaqAccordion } from './FaqAccordion';
export { InstructorCard } from './InstructorCard';
export { OutcomesList } from './OutcomesList';
export { PreviewVideoCard } from './PreviewVideoCard';
export { PriceCard } from './PriceCard';
export { RatingHistogram } from './RatingHistogram';
export { RelatedCourses } from './RelatedCourses';
export { ResourceList } from './ResourceList';
export { ReviewCard } from './ReviewCard';
export { SectionShell } from './SectionShell';
export { SkillChips } from './SkillChips';
export { StatRow } from './StatRow';
